import { Grid } from '@mui/material';
import CommentCard from './CommentCard';
import { CommentDTO } from '@/types/models';
const Comment = (props: CommentDTO) => {
  return <Grid container sx={{
    width: '100%',
    flexDirection: 'column',
    rowGap: 'var(--spacing_xs)'
  }} data-sentry-element="Grid" data-sentry-component="Comment" data-sentry-source-file="Comment.tsx">
      <CommentCard {...props} data-sentry-element="CommentCard" data-sentry-source-file="Comment.tsx" />
      {props.replies ? props.replies?.map(reply => <CommentCard key={reply.id} {...reply} isAdmin={true} />) : null}
    </Grid>;
};
export default Comment;